import constants from '../../constants.js'

export default {
  $k: constants,
  getImageUrl(name, stype, news) {
    return this.$k.imagebase + 'images/news/' + news.news_id + '/' + stype + '/' + name
  },
  replaceImageLink (src, news) {
    if(src.indexOf('=') < 0) return src
    let name = src.split('=').pop()
    let ret = this.getImageUrl(name, '500', news)
    return ret
  },
  processImagesAndLinks: async function(el, news)
  {
    let ims = el.querySelectorAll('img')
    if(ims.length > 0) {
      ims.forEach(im => {
        if(im.src) {
          let res = this.replaceImageLink(im.src, news)
          im.src = res
        }
      })
    }
    let links = el.querySelectorAll('a')
    let locs = window.location.href.split('/')
    let wad = locs[0] + '//' + locs[2] + '/'
    links.forEach(link => {
      if(link.href) {
        let href = link.href
        if(href.startsWith('https://www.illustrationweb')) {
          link.href = wad + href.split('/').slice(3).join('/')
        }
      }
    })
  }
  
}